import config from "@/lib/config";

const trimLeadingSlash = (value = "") => value.replace(/^\/+/, "");

export const resolveAssetUrl = (value) => {
  if (!value || typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (/^(https?:|data:|blob:)/i.test(trimmed)) return trimmed;
  if (trimmed.startsWith("//")) return `https:${trimmed}`;
  return `${config.backendUrl}/${trimLeadingSlash(trimmed)}`;
};

export const getRows = (response) => {
  const payload = response?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.rows)) return payload.rows;
  return [];
};

export const uniqueUrls = (urls) => Array.from(new Set(urls.filter(Boolean)));

export const normalizeKoreanTitle = (value = "") =>
  String(value)
    .replace(/\bPRAGMATIC\b/gi, "프라그마틱")
    .replace(/\bEVOLUTION\b/gi, "에볼루션")
    .replace(/\bMICROGAMING\b/gi, "마이크로게이밍")
    .replace(/\bBTI\b/gi, "비티아이")
    .replace(/\bBT1\b/gi, "비티원")
    .replace(/\bSABA\b/gi, "사바")
    .replace(/\bTITI\b/gi, "티티")
    .replace(/\bSA(?=게이밍|카지노|스포츠|\s|$)/gi, "에스에이")
    .replace(/\s+/g, " ")
    .trim();

export const getVendorTitle = (vendor, fallback = "게임사") =>
  normalizeKoreanTitle(
    vendor?.vendor_name_kr ||
      vendor?.vendor_name_ko ||
      vendor?.display_name ||
      vendor?.vendor_name ||
      fallback
  );

const normalizeVendorKey = (value) => String(value || "").trim().toLowerCase();

/** Internal Sportsnew is exposed in the live-sports catalog beside external vendors. */
export const isIntegratedSportsbookVendor = (vendor) => {
  const vendorName = normalizeVendorKey(vendor?.vendor_name);
  const lobbyId = normalizeVendorKey(
    vendor?.vendor_list?.lobby_id || vendor?.lobby_id
  );

  return vendorName === "sportsbook" || lobbyId === "sportsbook-self";
};

export const getIntegratedSportsbookRoute = (vendor) =>
  isIntegratedSportsbookVendor(vendor) ? "/sports?type=DOMESTIC" : "";

export const getGameTitle = (game, fallback = "게임") =>
  normalizeKoreanTitle(
    game?.game_name_ko ||
      game?.game_name_kr ||
      game?.name_ko ||
      game?.display_name ||
      game?.game_name ||
      game?.name ||
      fallback
  );

export const getVendorImages = (vendor) =>
  uniqueUrls([
    resolveAssetUrl(vendor?.image),
    resolveAssetUrl(vendor?.pc_image),
    resolveAssetUrl(vendor?.mobile_image),
    resolveAssetUrl(vendor?.thumbnail),
    resolveAssetUrl(vendor?.vendor_list?.thumbnails),
  ]);

export const getGameImage = (game) =>
  resolveAssetUrl(
    game?.game_image ||
      game?.image ||
      game?.thumbnail ||
      game?.thumbnail_url ||
      game?.pc_image ||
      game?.mobile_image
  );

export const formatCount = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number) || number <= 0) return "";
  return number.toLocaleString("ko-KR");
};

export const normalizeSearchText = (value = "") =>
  normalizeKoreanTitle(value)
    .toLowerCase()
    .replace(/\s+/g, "");

export const buildSearchText = (...values) =>
  values
    .filter((value) => value !== undefined && value !== null)
    .map((value) => `${String(value).toLowerCase()} ${normalizeSearchText(value)}`)
    .join(" ");

export const matchesKeyword = (keyword, ...values) => {
  const normalizedKeyword = normalizeSearchText(keyword);
  if (!normalizedKeyword) return true;
  return buildSearchText(...values).includes(normalizedKeyword);
};

export const dedupeGames = (games) => {
  const seen = new Set();

  return games.filter((game) => {
    const key = `${game?.game_id || game?.id || ""}:${game?.vendor || game?.vendor_name || ""}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
